import { Translate } from '@pegasus/translation/components';

export default Translate;
